import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { QrConfirmModalComponent } from '../../../../components/ui/qr-confirm-modal/qr-confirm-modal.component';

@Component({
  selector: 'app-distribution-scan',
  templateUrl: './distribution-scan.component.html',
  styleUrls: ['./distribution-scan.component.css']
})
export class DistributionScanComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() logData: any = null;
  @Input() mode: 'active' | 'view' = 'active'; // Add mode Input
  @Input() isAutoFilling: boolean = false; // State for Auto-fill Loading skeleton
  @Output() closeScan: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('deleteConfirmModal') deleteConfirmModal: QrConfirmModalComponent;

  // UI State
  activeTab: string = 'valid'; // 'valid' | 'error'
  skuCollapsed: boolean = false;
  serialInput: string = '';
  isPeripheralMode: boolean = true;
  useInternalCode: boolean = false;
  isCompleting: boolean = false;
  isDeleting: boolean = false;

  // Mock log info
  logInfo: any = {
    name: 'Phân phối Đại lý Hoàng Anh - Đợt 3',
    status: 'Chờ phân phối',
    dealer: 'Đại lý Hoàng Anh - TP.HCM',
    createdAt: '29/06/2026 15:30',
    createdBy: 'Nguyễn Văn A',
    ticketNumber: 'PX-2026-00123',
    expectedQty: 100
  };

  // Mock valid stamps
  validStamps: any[] = [
    { serial: 'QR-2026-00001', product: 'Sữa Vinamilk 1L', scannedAt: '15:32' },
    { serial: 'QR-2026-00002', product: 'Sữa Vinamilk 1L', scannedAt: '15:32' },
    { serial: 'QR-2026-00003', product: 'Nước mắm Chin-Su 500ml', scannedAt: '15:33' },
    { serial: 'QR-2026-00004', product: 'Nước mắm Chin-Su 500ml', scannedAt: '15:33' },
    { serial: 'QR-2026-00005', product: 'Dầu ăn Neptune 2L', scannedAt: '15:34' },
    { serial: 'QR-2026-00006', product: 'Sữa Vinamilk 1L', scannedAt: '15:34' },
    { serial: 'QR-2026-00007', product: 'Mì Hảo Hảo gói', scannedAt: '15:35' }
  ];

  // Mock error stamps
  errorStamps: any[] = [
    { serial: 'QR-2026-99001', reason: 'Mã tem đã tồn tại trong log phân phối' },
    { serial: 'QR-2026-99002', reason: 'Tem đã bị khóa bởi log khác' }
  ];

  // Mock SKU stats
  skuStats: any[] = [
    { name: 'Sữa Vinamilk 1L', count: 3 },
    { name: 'Nước mắm Chin-Su 500ml', count: 2 },
    { name: 'Dầu ăn Neptune 2L', count: 1 },
    { name: 'Mì Hảo Hảo gói', count: 1 }
  ];

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(): void {
    // Mock updating log info when logData changes or when opening modal
    if (this.logData) {
      this.logInfo = {
        ...this.logInfo,
        name: this.logData.name || this.logInfo.name,
        status: this.logData.status === 'PENDING' ? 'Chờ phân phối' : 'Đã phân phối',
        dealer: this.logData.dealer || this.logInfo.dealer,
        ticketNumber: this.logData.ticketNumber || this.logInfo.ticketNumber
      };
    }
  }

  close() {
    this.closeScan.emit();
  }

  togglePeripheralMode() {
    this.isPeripheralMode = !this.isPeripheralMode;
  }

  deleteValidStamp(index: number) {
    this.validStamps.splice(index, 1);
  }

  deleteErrorStamp(index: number) {
    this.errorStamps.splice(index, 1);
  }

  switchTab(tab: string) {
    this.activeTab = tab;
  }

  toggleSku() {
    this.skuCollapsed = !this.skuCollapsed;
  }

  clearErrors() {
    this.errorStamps = [];
  }

  downloadTemplate() {
    // Mock download action
    console.log('Downloading template...');
  }

  importExcel() {
    // Mock import action
    console.log('Importing Excel...');
  }

  onSerialSubmit() {
    if (!this.serialInput.trim()) return;
    // Mock: add to valid
    this.validStamps.unshift({
      serial: this.serialInput.trim(),
      product: 'Sản phẩm mới',
      scannedAt: new Date().toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })
    });
    this.serialInput = '';
  }

  getProgressPercent(): number {
    if (!this.logInfo.expectedQty || this.logInfo.expectedQty === 0) return 0;
    return Math.min((this.validStamps.length / this.logInfo.expectedQty) * 100, 100);
  }

  getProgressColor(): string {
    const ratio = this.validStamps.length / (this.logInfo.expectedQty || 1);
    if (ratio > 1) return '#e74c3c';
    if (ratio > 0.9) return '#f2a654';
    return '#46be8a';
  }

  isOverExpected(): boolean {
    return this.validStamps.length > (this.logInfo.expectedQty || 0);
  }

  onSaveAndClose() {
    this.isCompleting = true;
    setTimeout(() => {
      this.isCompleting = false;
      this.close(); // Save and close
    }, 1000);
  }

  onComplete() {
    this.isCompleting = true;
    setTimeout(() => {
      this.isCompleting = false;
      // Mock: would call API
    }, 2000);
  }

  getTotalSkuCount(): number {
    return this.skuStats.reduce((sum, s) => sum + s.count, 0);
  }

  // Delete Modal
  openDeleteConfirm(): void {
    if (this.deleteConfirmModal) {
      this.deleteConfirmModal.show();
    }
  }

  closeDeleteConfirm(): void {
    if (this.deleteConfirmModal) {
      this.deleteConfirmModal.hide();
    }
  }

  confirmDelete(): void {
    this.isDeleting = true;
    // Mock API call to delete
    setTimeout(() => {
      this.isDeleting = false;
      this.closeDeleteConfirm();
      this.close(); // Also close the scan modal after deleting
    }, 1000);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution-scan/distribution-scan.component.ts